import "./SinglePostTemplate.module.css"
import GusRuballoNavigation from "@/reusable_sections/Header"
import SinglePostTemplate from "./sections/SinglePostTemplate"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <GusRuballoNavigation />
      <SinglePostTemplate />
      <Footer />
    </div>
  )
}
